"use strict";

exports.__esModule = true;
exports.tablePropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var sort = (0, _propTypes.shape)({
  key: _propTypes.string.isRequired,
  descending: _propTypes.bool
});
var columns = (0, _propTypes.arrayOf)((0, _propTypes.shape)({
  cell: _propTypes.func,
  content: _propTypes.node.isRequired,
  headerCell: _propTypes.func,
  key: _propTypes.string.isRequired,
  label: _propTypes.string,
  maxWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  minWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  primary: _propTypes.bool,
  sortable: _propTypes.bool,
  sortComparator: _propTypes.func,
  textAlign: (0, _propTypes.oneOf)(Object.keys(_constants.COLUMN_ALIGN)),
  width: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
}));
var rows = (0, _propTypes.arrayOf)(_propTypes.object);
var messages = (0, _propTypes.shape)({
  deselectAllRows: _propTypes.string.isRequired,
  deselectRow: _propTypes.string.isRequired,
  selectAllRows: _propTypes.string.isRequired,
  selectRow: _propTypes.string.isRequired,
  selectedRows: _propTypes.string.isRequired,
  sortColumnAscending: _propTypes.string.isRequired,
  sortColumnDescending: _propTypes.string.isRequired
});
var tablePropTypes = {
  columns: columns,
  data: rows.isRequired,
  defaultSelectedRows: rows,
  defaultSort: sort,
  density: (0, _propTypes.oneOf)(Object.keys(_constants.DENSITY)),
  hideHeader: _propTypes.bool,
  hideTitle: _propTypes.bool,
  highContrast: _propTypes.bool,
  messages: messages,
  onSort: _propTypes.func,
  onToggleAllRows: _propTypes.func,
  onToggleRow: _propTypes.func,
  rowKey: _propTypes.string,
  scrollable: _propTypes.bool,
  selectable: _propTypes.bool,
  selectedRows: rows,
  sort: sort,
  sortable: _propTypes.bool,
  sortComparator: _propTypes.func,
  striped: _propTypes.bool,
  title: _propTypes.node.isRequired,
  titleAppearance: (0, _propTypes.oneOf)(Object.keys(_constants.TITLE_ELEMENT)),
  titleAs: (0, _propTypes.oneOf)(Object.keys(_constants.TITLE_ELEMENT))
};
exports.tablePropTypes = tablePropTypes;